<script>
		import { user } from "../client.svelte.js"
		import {exhibit_URL} from "../core.js";

		let { data: exhibit, onselect } = $props()

		let exhibited = $derived((user.isMaster) ? game.exhibits.includes(exhibit.ID) : (exhibit.ID === game.present))
</script>


<!------------------------------- HTML ------------------------------------->

<div class="card" class:exhibited onclick={onselect.bind(exhibit)}>
	<h3>{exhibit.title}</h3>
	<div class="content">
		<img class=image src={exhibit_URL(exhibit) ?? "/static/images/missing.svg"} alt={exhibit.ID} title={exhibit.ID}>
	</div>
	<p class="caption">{exhibit.caption}</p>
</div>


<!------------------------------- STYLE ------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	.card
		width: 264px
		margin: 8px
		border: grey 1px
		border-radius: 4px
		background-color: #333
		padding: 0 4px
		overflow: clip

		&.exhibited
			border: colors.$primary 2px solid

		img
			width: 256px
			max-height: 256px
			margin: auto

		p
			max-width: 260px

	h3
		margin: 8px 0 4px 0
		color: colors.$white

	.caption
		padding: 0 0 8px 0
		max-height: 7ch
		overflow: clip

</style>